<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(2215,114,2);
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Location visualization
        </p>
       
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
                In this visualization section, 
                We showed the <strong style="font-size:20px;">locations</strong> of MDD-related snp, genes, RNA and methylated genes on different chromosomes. <br/>
                Click the region of interest in the plot, and the corresponding information and sequence visualization from <a href="http://epigenomegateway.wustl.edu/browser/">WashU Browser</a> will be displayed below.                
               </div>
        </el-card>
        <br/><br/>
        Choose chromosome:&nbsp;&nbsp;&nbsp;<el-select @change="selectChanged" v-model="activeChromosome" placeholder="Choose type" >
            <el-option
                v-for="item in chromosomeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
        <br>
           
        <div id="plot">
            <LocationVue :plotData="plotData" @click="click" style="margin-left: auto;margin-right: auto;">
            </LocationVue>
        </div>
        <el-descriptions class="snp-description" :column="3" style="width: 100%" v-if="this.activeOmics=='snp'" border>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px">
                <template slot="label" >SNP</template>
                {{this.activeData.snp}} 
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Allele</template>
                {{this.activeData.allele}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Score in DisGeNET</template>
                {{this.activeData.score_dgn}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Chromosome</template>
                {{this.activeData.chromosome}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Position</template>
                {{this.activeData.position}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene</template>
                {{this.activeData.gene}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Disease-CUI</template>
                {{this.activeData.disease_cui}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Source</template>
                {{this.activeData.source}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >PMID </template>
                <template>
                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">   {{this.activeData.pmid}}  </a>
                </template>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="gene-description" :column="3" style="width: 100%" v-if="this.activeOmics=='gene'" border>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px">
                <template slot="label" >Gene ID</template>
                {{this.activeData.gene_id}} 
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene name</template>
                {{this.activeData.gene_name}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene aliases</template>
                {{this.activeData.gene_aliases}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Score in DisGeNET</template>
                {{this.activeData.score_dgn}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Map location</template>
                {{this.activeData.map_location}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Chromosome</template>
                {{this.activeData.chromosome}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Start</template>
                {{this.activeData.start}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >End</template>
                {{this.activeData.end}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Disease-CUI</template>
                {{this.activeData.disease_cui}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Source</template>
                {{this.activeData.source}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >PMID </template>
                <template>
                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">   {{this.activeData.pmid}}  </a>
                </template>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="rna-description" :column="3" style="width: 100%" v-if="this.activeOmics=='rna'" border>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px">
                <template slot="label" >Gene ID</template>
                {{this.activeData.gene_id}} 
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene name</template>
                {{this.activeData.gene_name}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene aliases</template>
                {{this.activeData.gene_aliases}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Original name</template>
                {{this.activeData.rna_name}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Score in DisGeNET</template>
                {{this.activeData.score_dgn}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Map location</template>
                {{this.activeData.map_location}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Chromosome</template>
                {{this.activeData.chromosome}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Start</template>
                {{this.activeData.start}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >End</template>
                {{this.activeData.end}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Disease-CUI</template>
                {{this.activeData.disease_cui}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Source</template>
                {{this.activeData.source}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >PMID </template>
                <template>
                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">   {{this.activeData.pmid}}  </a>
                </template>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="methy-description" :column="3" style="width: 100%" v-if="this.activeOmics=='methylation'" border>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px">
                <template slot="label" >Gene ID</template>
                {{this.activeData.gene_id}} 
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene name</template>
                {{this.activeData.gene_name}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Gene aliases</template>
                {{this.activeData.gene_aliases}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px">
                <template slot="label" >Probe ID</template>
                {{this.activeData.probe}} 
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Map location</template>
                {{this.activeData.map_location}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Chromosome</template>
                {{this.activeData.chromosome}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Probe position</template>
                {{this.activeData.probe_position}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Start</template>
                {{this.activeData.start}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >End</template>
                {{this.activeData.end}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >Source</template>
                {{this.activeData.source}}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                <template slot="label" >PMID </template>
                <template>
                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">   {{this.activeData.pmid}}  </a>
                </template>
            </el-descriptions-item>
        </el-descriptions>
        <br><br><br>
        <div v-loading="loading">
            <iframe ref="iframe" width="100%" height="500px" src="washu.html" id="childFrame" @load="this.washU"></iframe>
        </div>

  
    </div>
     
</template>

<script>

import{Loading}from'element-ui';
import LocationVue from '@/chart/Locationchart.vue';
export default{
    data(){
        return{
            chromosomeOption:[{
                value: '1',
                label: '1'
                },{
                value: '2',
                label: '2'
                },{
                value: '3',
                label: '3'
                },{                
                value: '4',
                label: '4'
                },{                
                value: '5',
                label: '5'
                },{                
                value: '6',
                label: '6'
                },{                
                value: '7',
                label: '7'
                },{                
                value: '8',
                label: '8'
                },{                
                value: '9',
                label: '9'
                },{                
                value: '10',
                label: '10'
                },{                
                value: '11',
                label: '11'
                },{                
                value: '12',
                label: '12'
                },{                
                value: '13',
                label: '13'
                },{                
                value: '14',
                label: '14'
                },{                
                value: '15',
                label: '15'
                },{                
                value: '16',
                label: '16'
                },{                
                value: '17',
                label: '17'
                },{                
                value: '18',
                label: '18'
                },{                
                value: '19',
                label: '19'
                },{                
                value: '20',
                label: '20'
                },{                
                value: '21',
                label: '21'
                },{                
                value: '22',
                label: '22'
                },{                
                value: 'X',
                label: 'X'
                },{                
                value: 'Y',
                label: 'Y'
            }],
            activeChromosome:2,
            activeOmics:null,
            activeData:[],
            jsonData:{},
            plotData:[],
            color_dict:{
                gene: "#7b9ce1",
                snp: "#bd6d6c",
                rna: "#75d874",
                methy: "#e0bc78",
            },
            loading: false,
            startText:0,
            endText:100000
        }
    },
    components:{
        LocationVue,
    },
    mounted () {
        this.iframeLoad();
        var loadingInstance = Loading.service({
            target:document.querySelector('#plot')
        });
        this.axios.get(this.GLOBAL.rootAddress+'visualization/Location',{
        params: { 
            'chromosome': this.activeChromosome
            }
        })
        .then(response=> {  
            loadingInstance.close();    
            this.plotData=[]        
            this.jsonData=response.data; 
            this.dataProcessed()
            this.activeOmics='gene'
            this.jsonData.gene.forEach((ele) => {
            if(ele.gene_name=='GAD1'){
                this.activeData=ele
            }
        });
        })
        .catch(error=> {
            loadingInstance.close();
            console.log(error);
        });
    },
    methods:{
        getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#plot')
            });
            this.axios.get(this.GLOBAL.rootAddress+'visualization/Location',{
            params: { 
                'chromosome': this.activeChromosome
                }
            })
            .then(response=> {  
                loadingInstance.close();    
                this.plotData=[]        
                this.jsonData=response.data; 
                this.dataProcessed()
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        selectChanged(){
            this.getData()
        },
        dataProcessed(){
            this.jsonData.snp.forEach((ele) => {
                this.plotData.push({
                    name: ele.snp,
                    value:[
                        ele.my_state,
                        ele.position,
                        ele.position,
                    ],
                    allele:ele.allele,
                    gene:ele.gene,
                    itemStyle: {
                        color: this.color_dict.snp,
                    },
                });
            });
            this.jsonData.gene.forEach((ele) => {
                this.plotData.push({
                    name: ele.gene_name,
                    value:[
                        ele.my_state,
                        ele.start,
                        ele.end,
                    ],
                    id:ele.gene_id,
                    location:ele.map_location,
                    type:ele.gene_type,
                    itemStyle: {
                        color: this.color_dict.gene,
                    },
                });
            });       
            this.jsonData.rna.forEach((ele) => {
                var tmpName
                if(ele.gene_name!=null)tmpName=ele.gene_name
                else tmpName=ele.rna_name
                this.plotData.push({
                    name: tmpName,
                    id:ele.gene_id,
                    value:[
                        ele.my_state,
                        ele.start,
                        ele.end,
                    ],
                    location:ele.map_location,
                    type:ele.gene_type,
                    itemStyle: {
                        color: this.color_dict.rna,
                    },
                });
            });
            this.jsonData.methy.forEach((ele) => {
                this.plotData.push({
                    name: ele.gene_name,
                    value:[
                        ele.my_state,
                        ele.start || ele.probe_position-10000,
                        ele.end || ele.probe_position+10000,
                    ],
                    id:ele.gene_id,
                    probe:ele.probe,
                    gene_location:ele.start,
                    location:ele.map_location,
                    itemStyle: {
                        color: this.color_dict.methy,
                    },
                });
            });
        },
        click(clickItem){
            if(clickItem.value[0]==0){
                this.activeOmics='snp'
                this.jsonData.snp.forEach((ele) => {
                    if(ele.snp==clickItem.name){
                        this.activeData=ele
                        document.getElementById('childFrame').contentWindow.location.reload();
                    }
                });
            }else if(clickItem.value[0]==1){
                this.activeOmics='gene'
                this.jsonData.gene.forEach((ele) => {
                    if(ele.gene_name==clickItem.name){
                        this.activeData=ele
                        document.getElementById('childFrame').contentWindow.location.reload();
                    }
                });
            }else if(clickItem.value[0]==2){
                this.activeOmics='rna'
                this.jsonData.rna.forEach((ele) => {
                    if(ele.gene_name==clickItem.name){
                        this.activeData=ele
                        document.getElementById('childFrame').contentWindow.location.reload();
                    }
                });
            }else if(clickItem.value[0]==3){
                this.activeOmics='methylation'
                this.jsonData.methy.forEach((ele) => {
                    if(ele.gene_name==clickItem.name){
                        this.activeData=ele
                        document.getElementById('childFrame').contentWindow.location.reload();
                    }
                });
            }
            
        },
        washU(){
            if(this.activeOmics=='snp')
			this.$refs.iframe.contentWindow.update(this.activeData.chromosome,this.activeData.position-150,this.activeData.position+150);
            else if(this.activeOmics=='methylation'&this.activeData.start==null)
            this.$refs.iframe.contentWindow.update(this.activeData.chromosome,this.activeData.probe_position-150,this.activeData.probe_position+150)
            else this.$refs.iframe.contentWindow.update(this.activeData.chromosome,this.activeData.start,this.activeData.end);
            // document.getElementById('childFrame').contentWindow.location.reload();
		},
        iframeLoad() {
            this.loading = true;
            const iframe = this.$refs.iframe;
            // 兼容处理
            if (iframe.attachEvent) {
                // IE
                iframe.attachEvent("onload", () => {
                this.loading = false;
                });
            } else {
                // 非IE
                iframe.onload = () => {
                this.loading = false;
                };
            }
        },
    },
}
</script>


